import ReactDOM from 'react-dom/client';
import './styles.css';
import * as Sentry from '@sentry/react';
import { env, isLocal, loadRuntimeConfig } from '@/config';
import { scrubBreadcrumb, scrubEvent } from '@/lib/sentryScrub';

void (async () => {
  // Load /config.json before importing any module that reads config at
  // module-evaluation time (notably the API client modules that pin
  // apiUrl at construction). docs/RELEASE_FLOW.md §13.
  await loadRuntimeConfig();

  Sentry.init({
    dsn: 'https://9cf750be2bf6c5c36508bb96e1cfa2e1@o4510147544350720.ingest.us.sentry.io/4510147564011520',
    sendDefaultPii: false,
    environment: env,
    enabled: !isLocal,
    // Strip PHI/PII before anything leaves the browser: drop query strings from
    // breadcrumb/event URLs, drop console + DOM breadcrumbs, mask sensitive keys
    // in free text. (Cyb-011)
    beforeBreadcrumb: scrubBreadcrumb,
    beforeSend: scrubEvent,
  });

  // Dynamic imports — see comment above. Static imports would evaluate
  // the API client modules before runtime config has loaded.
  const [ { Providers }, { AppRouterProvider } ] = await Promise.all([
    import('@/providers/index'),
    import('./providers/RouterProvider'),
  ]);

  const rootElement = document.getElementById('app');
  if (rootElement !== null && !rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <Providers>
        <AppRouterProvider />
      </Providers>,
    );
  }
})();
